import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Services from '../views/Services.vue';
import Contact from '../views/Contact.vue';
import notFound from '../views/notFound.vue';
import thankyou from '../views/ThankYou.vue';
import privacy from '../views/legal/privacy.vue';
import terms from '../views/legal/termsAndService.vue';
import covidModel from '../views/covidModel';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },

   {
      path: '/services',
      name: 'services',
      component: Services
   },


   {
      path: '/contact',
      name: 'contact',
      component: Contact
   },


   {
      path: '/covid-model',
      name: 'covidModel',
      component: covidModel
   },


   {
      path: '/privacy',
      name: 'privacy',
      component: privacy
   },


   {
      path: '/terms',
      name: 'terms',
      component: terms
   },


   {
      path: '/thankyou',
      name: 'terms',
      component: thankyou
   },


   {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
   {
      path: '*',
      name: 'notFound',
      component: notFound
   },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
